<section class="panel p-4 registrador">
  <app-modal-confirmacao-ponto
    [visivel]="confirmacaoPontoVisivel"
    [titulo]="confirmacaoPontoTitulo"
    [nome]="confirmacaoPontoNome"
    [horario]="confirmacaoPontoHorario">
  </app-modal-confirmacao-ponto>

  <div class="registrador-conteudo" [class.registrador-conteudo-terminal]="terminalPublico && terminalAutorizado">
    <div class="registrador-principal">
      <app-relogio-registrador
        [agora]="agora"
        [dataFormatada]="dataFormatada">
      </app-relogio-registrador>

      <app-painel-registro-manual
        *ngIf="!terminalPublico"
        [empregadores]="empregadores"
        [empregadorSelecionado]="empregadorSelecionado"
        (empregadorSelecionadoChange)="selecionarEmpregador($event)"
        (iniciarRegistro)="abrirCameraRegistro()">
      </app-painel-registro-manual>

      <app-painel-ativacao-terminal
        *ngIf="terminalPublico && !terminalAutorizado"
        [codigoAtivacao]="codigoAtivacao"
        [ativandoTerminal]="ativandoTerminal"
        (codigoAtivacaoChange)="codigoAtivacaoChange.emit($event)"
        (ativarTerminal)="ativarTerminal.emit()">
      </app-painel-ativacao-terminal>

      <app-painel-camera-registro
        *ngIf="!terminalPublico || terminalAutorizado"
        [ativa]="cameraAtiva"
        [modo]="cameraModo"
        [margemSuperior]="!terminalPublico"
        [rostoDetectado]="rostoDetectado"
        [provaVidaOk]="provaVidaOk"
        [capturando]="capturando"
        [mensagem]="mensagemCamera"
        [caixaFace]="caixaFace"
        [zoomVisual]="zoomVisualCamera"
        (confirmar)="capturarERegistrar()">
      </app-painel-camera-registro>
    </div>

    <aside *ngIf="terminalPublico" class="registrador-status">
      <div *ngIf="terminalAutorizado && terminalNome" class="text-secondary small mb-2">
        Terminal: {{ terminalNome }}
      </div>

      <app-painel-status-terminal
        [online]="online"
        [cacheBiometricoValido]="cacheBiometricoValido"
        [totalFuncionariosCache]="totalFuncionariosCache"
        [ultimaConexaoOnline]="ultimaConexaoOnline"
        [registrosPendentesOffline]="registrosPendentesOffline"
        [sincronizandoOffline]="sincronizandoOffline"
        [terminalAutorizado]="terminalAutorizado"
        [terminalToken]="terminalToken"
        (alternarFilaOffline)="alternarFilaOffline()">
      </app-painel-status-terminal>

      <app-painel-fila-offline
        *ngIf="filaOfflineVisivel"
        [registros]="resumosFilaOffline"
        [totalPendentes]="totalPendentesOffline"
        [totalFalhas]="totalFalhasOffline"
        [totalSincronizados]="totalSincronizadosOffline">
      </app-painel-fila-offline>
    </aside>
  </div>
</section>
